/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApImprovement } from './ApImprovement';
import {
    ApImprovementFromJSON,
    ApImprovementFromJSONTyped,
    ApImprovementToJSON,
} from './ApImprovement';
import type { ResultCalcAp } from './ResultCalcAp';
import {
    ResultCalcApFromJSON,
    ResultCalcApFromJSONTyped,
    ResultCalcApToJSON,
} from './ResultCalcAp';

/**
 * 計算結果
 * @export
 * @interface ResultAp
 */
export interface ResultAp {
    /**
     * 計算結果一覧
     * @type {Array<ResultCalcAp>}
     * @memberof ResultAp
     */
    resultList?: Array<ResultCalcAp>;
    /**
     * 効果一覧
     * @type {Array<ApImprovement>}
     * @memberof ResultAp
     */
    improvementList?: Array<ApImprovement>;
}

/**
 * Check if a given object implements the ResultAp interface.
 */
export function instanceOfResultAp(value: object): value is ResultAp {
    return true;
}

export function ResultApFromJSON(json: any): ResultAp {
    return ResultApFromJSONTyped(json, false);
}

export function ResultApFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultAp {
    if (json == null) {
        return json;
    }
    return {
        
        'resultList': json['resultList'] == null ? undefined : ((json['resultList'] as Array<any>).map(ResultCalcApFromJSON)),
        'improvementList': json['improvementList'] == null ? undefined : ((json['improvementList'] as Array<any>).map(ApImprovementFromJSON)),
    };
}

export function ResultApToJSON(value?: ResultAp | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'resultList': value['resultList'] == null ? undefined : ((value['resultList'] as Array<any>).map(ResultCalcApToJSON)),
        'improvementList': value['improvementList'] == null ? undefined : ((value['improvementList'] as Array<any>).map(ApImprovementToJSON)),
    };
}

